module.exports = __webpack_public_path__ + "img/servico-comtabilista.0c671fbf.jpg";